<template>
  <div class="sidebar">
    <div class="menu">
      <router-link class='intro' :to="{name: 'pages.home'}">
        <div>
          <img :src="logo" alt="Broodje Dunner logo">
        </div>
      </router-link>

      <div class='menu-group'>
        <router-link
            class="menu-link"
            :to="{name: 'pages.home'}"
        >
          Home
        </router-link>

        <router-link
            class="menu-link"
            :to="{name: 'pages.books'}"
        >
          Jouw boeken
        </router-link>

        <router-link
            class="menu-link"
            :to="{name: 'pages.progress'}"
        >
          Jouw voortgang
        </router-link>

        <router-link
            class="menu-link"
            :to="{name: 'pages.bookmarks'}"
        >
          Jouw favorieten
        </router-link>

        <router-link
            class="menu-link"
            :to="{name: 'pages.messages'}"
        >
          Berichten van Bo
        </router-link>

        <router-link
            class="menu-link"
            :to="{name: 'pages.settings'}"
        >
          Instellingen
        </router-link>
      </div>
    </div>

    <div class='bottom-group'>
      <img :src="name" alt="Bo de Wit" class="name-logo">

      <span
          class="logout btn wide "
          @click="logout"
      >
        Log uit
      </span>
    </div>
  </div>
</template>

<script>
import {
  mapActions,
} from "vuex";
import logo from "@/assets/images/logo.svg";
import nameLogo from "@/assets/images/name-logo.svg"

export default {
  name: "Sidebar",
  data() {
    return {
      logo: logo,
      name: nameLogo,
    };
  },
  methods: {
    ...mapActions("user", [
      "logout",
    ]),
  },
};
</script>
